<template>
    <div>
        <link v-for="(css, key) in estilos.slice().reverse()" v-bind:key="key" rel="stylesheet" :href="css">
    </div>    
</template>

<script>
    export default {
        name: 'App',
        props: ['estilos'],
        data() {
            return {

            }
        },
    }
</script>

<style>

</style>
